import React from "react";
import Modal from "react-modal";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import Button from "./Button";

Modal.setAppElement("#___gatsby");

const PopupModalComponent = ({ data, isOpen, handleClose }) => {
  const popupImage = getImage(data.background) || data.background;
  const { title, subheading, detail, buttonUrl, buttonText } = data;
  // console.log('GETIMAGE', popupImage.images.fallback.src);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      contentLabel="Example Modal"
      style={{
        overlay: {
          zIndex: 50,
        },
        content: {
          backgroundColor: "#333",
          width: "1080px",
          height: "700px",
          maxWidth: "calc(100% - 40px)",
          maxHeight: "calc(100% - 40px)",
          top: "50%",
          left: "50%",
          inset: "20px",
          // transform: 'translate(-50%, -50%)',
          margin: "auto",
        },
      }}
    >
      <GatsbyImage
        image={popupImage}
        objectFit={"cover"}
        objectPosition={"ceneter center"}
        style={{
          gridArea: "1/1",
          // You can set a maximum height for the image, if you wish.
          position: "absolute",
          height: "100%",
          width: "100%",
          top: 0,
          left: 0,
          opacity: 0.5,
        }}
        layout="fullWidth"
        // You can optionally force an aspect ratio for the generated image
        // This is a presentational image, so the alt should be an empty string
        alt=""
        formats={["auto", "webp", "avif"]}
      />
      <div
        style={{
          // By using the same grid area for both, they are stacked on top of each other
          gridArea: "1/1",
          position: "relative",
          // This centers the other elements inside the hero component
          placeItems: "center",
          display: "grid",
          height: "100%",
          width: "100%",
        }}
      >
        {/* Any content here will be centered in the component */}
        {title && <h1 className="has-text-weight-bold page-title">{title}</h1>}
        {subheading && <h2 className="popup-subtitle">{subheading}</h2>}
        <center>
          <div style={{ width: "200px", marginTop: ".5em" }}>
            <Button
              title={buttonText}
              link={buttonUrl}
              className="link-button-orange is-size-4 has-text-weight-bold"
            />
          </div>
        </center>
        {detail ? <h3 className="page-detail">{detail}</h3> : null}
      </div>
      {/* </div> */}
      <button
        style={{
          position: "absolute",
          right: "10px",
          top: "10px",
          height: "2rem",
          width: "2rem",
          zIndex: 20,
          background: "#ffffff",
          display: "block",
          border: "none",
          outline: "none",
          borderRadius: "999px",
          cursor: "pointer",
        }}
        title="Close Popup"
        onClick={handleClose}
      >
        X
      </button>
    </Modal>
  );
};

export default PopupModalComponent;
